module.exports = __WEBPACK_EXTERNAL_MODULE_23__;


//////////////////
// WEBPACK FOOTER
// external "antd"
// module id = 23
// module chunks = 66